///<reference path="../Core/Resources.js"/>
window.localizedStrings["ipsfileupload"] = {
  textdropareawithbrowse: 'Drag and Drop or <span class="hyperlink">Select Files</span> to Upload',
  textdroparea: "Drag and Drop Files to Upload",
  errorallowedtypes: "File type is not allowed",
  errormaxfilesize: "Exceeded file size limit",
  errormaxfilesinprogress: "Exceeded maximum files allowed limit",
};
